<template>
    <el-dialog :visible.sync="visible" :title="优果兑换" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
                 <el-form-item label="手机号码:" prop="memberMobile">
                     <el-input v-model="dataForm.memberMobile" :readonly="true" placeholder="手机号码"></el-input>
                 </el-form-item>
                 <el-form-item label="会员名称:" prop="memberName">
                     <el-input v-model="dataForm.memberName" :readonly="true" placeholder="会员名称"></el-input>
                 </el-form-item>
                 <el-form-item label="优果余额:" prop="cashBalance">
                     <el-input v-model="dataForm.cashBalance" :readonly="true" placeholder="优果余额"></el-input>
                 </el-form-item>
                 <el-form-item label="兑换余额" prop="amount">
                     <el-input-number v-model="dataForm.amount" :disabled="viewStatus"  placeholder="兑换余额"></el-input-number>
                 </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"  @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce"
    export default {
        data() {
            return {
                visible: false,
                active:0,
                viewStatus:false,
                dataForm: {
                    memberId: '',
                    memberName:'',
                    memberMobile:'',
                    cashBalance:0,
                    amount:'',
                    type:''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    amount: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                debugger;
                this.visible = true
                this.$nextTick(() => {
                    //this.$refs['dataForm'].resetFields()
                    this.dataForm.id=id;
                    this.getMemberInfo();
                })
            },
            // 获取信息
            getMemberInfo() {
                this.$http.get(`/ums/memberbalance/getByMemberId/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.memberId=res.data.memberId;
                    this.dataForm.memberName=res.data.memberName;
                    this.dataForm.memberMobile=res.data.mobileNumber;
                    this.dataForm.cashBalance=res.data.integrationBalance
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function() {
                console.log(this.dataForm.transferMobile);
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }

                    this.$http['put']('/ums/memberbalance/memberTransferIntegrationShare', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
